import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getOneOrganizationKey } from "./useGetOneOrganization";

export type UpdateCompanyPayload = {
    name?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zipcode?: string;
    country?: string;
    phone?: string;
    email?: string;
    registrationNumber?: string; // VAT number
};

export const useUpdateOrganization = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ companyId, data }: { companyId: number; data: UpdateCompanyPayload }) => {
            const response = await loggedInApiCall.put(`/api/organizations/${companyId}`, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        },
        onSuccess: (_, variables) => {
            // Invalidate company queries to refetch updated data
            queryClient.invalidateQueries([getOneOrganizationKey, variables.companyId.toString()]);
            queryClient.invalidateQueries(["getCompanies"]);
        },
    });
};
